import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { Parameter } from "../models/parameter";
import { Role } from "../models/role";

@Injectable({
    providedIn: 'root'
})

export class AdminService {
    constructor(private http: HttpClient) { }

    getParameters() {
        return this.http.get<Parameter[]>(`${environment.API}parameters`).pipe();
    }

    getParameterByCode(code: string) {
        return this.http.get<Parameter>(`${environment.API}parameters/${code}`).pipe();
    }

    updateParameter(id: number, body) {
        return this.http.patch<any>(`${environment.API}parameters/${id}`, body).pipe();
    }

    validateParameter(code: string, body) {
        return this.http.post<any>(`${environment.API}parameters/${code}/validate`, body).pipe();
    }

    getRoles() {
        return this.http.get<Role[]>(`${environment.API}roles`).pipe();
    }

    createRole(body) {
        return this.http.post<any>(`${environment.API}roles`, body).pipe();
    }

    updateRole(id: number, body) {
        return this.http.put<any>(`${environment.API}roles/${id}`, body).pipe();
    }

    deleteRole(id: number) {
        return this.http.delete<any>(`${environment.API}roles/${id}`).pipe();
    }
}